import { Component, type ReactNode } from 'react';
import { makeT } from './i18n';

/** A page that fails shows what happened and a reload, never a blank screen. */
export class CrashScreen extends Component<{ children: ReactNode }, { error: Error | null }> {
  public override state: { error: Error | null } = { error: null };

  public static getDerivedStateFromError(error: Error) {
    return { error };
  }

  public override render() {
    if (!this.state.error) return this.props.children;
    const t = makeT(document.documentElement.lang || navigator.language || 'en');
    return (
      <div className="crash">
        <h1>{t('crash.title')}</h1>
        <p className="muted">{t('crash.hint')}</p>
        <pre className="crash-detail">{String(this.state.error.message).slice(0, 300)}</pre>
        <button type="button" className="primary" onClick={() => location.reload()}>{t('crash.reload')}</button>
      </div>
    );
  }
}
